module.exports = __webpack_public_path__ + "static/img/goodsTab-min.e53c2061.png";